const buildChildFkReset = (model_name, target, values) => {
  if (model_name === 'user') return {}
  return {
    companycontract: target === 'companycontract' ? values?.companycontract : null,
    companyservice: target === 'companyservice' ? values?.companyservice : null,
    companyuser: target === 'companyuser' ? values?.companyuser : null,
  }
}

class Callbacks {
  static formToFilterHandler(model_name, record_id, company) {
    return function formToFilter(values, extra, meta, state) {
      const filter = !!company ? { [model_name]: [null, record_id], company } : { [model_name]: record_id }

      return {
        ...filter,
        ...values
      }
    }
  }

  static formToRecordHandler(model_name, record_id, company) {
    return function formToRecord(values, extra, meta) {
      const target = values?.target

      return _.merge(
        {},
        {
          target,
          company: extra?.company || company,
          priority: values?.priority,
          orderlimit: {
            limit_type: values?.orderlimit?.limit_type,
            limit_amount: values?.orderlimit?.limit_amount,
            limit_count: values?.orderlimit?.limit_count,
            payment_type: values?.orderlimit?.payment_type,
            period: values?.orderlimit?.period
          }
        },
        buildChildFkReset(model_name, target, values),
        { [model_name]: extra?.[model_name] || record_id }
      )
    }
  }

  static getEmptyFormHandler(parentModelName) {
    return function getEmptyForm() {
      return {
        priority: 0,
        target: parentModelName
      }
    }
  }
}

export default Callbacks
